/**
 *
 * PriorityHighTag
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import { COLORS } from 'theme';
import { ChevronDoubleUpIcon } from 'assets/v2/icons';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.redDark};
    background: ${COLORS.redLight};
    border-color: ${COLORS.red};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};

    &&& .MuiChip-icon path {
      fill: ${COLORS.red};
    }
  }
`;

function PriorityHighTag(props) {
  return <StyledTag label="High" icon={<ChevronDoubleUpIcon />} {...props} />;
}

export default memo(PriorityHighTag);
